"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpreedlyAsync = exports.tokenizePayPal = exports.tokenizeCreditCard = exports.tokenizeBankAccount = void 0;
var constants_1 = require("../constants");
var typeAdapters_1 = require("../typeAdapters");
function tokenizeBankAccount(data, config) {
    if (config.spreedlyEnvironmentKey === undefined) {
        return Promise.reject(new Error('Spreedly is not configured.'));
    }
    return fetch(constants_1.SPREEDLY_TOKENIZER_URL +
        '?' +
        new URLSearchParams({ environment_key: config.spreedlyEnvironmentKey }), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            payment_method: {
                bank_account: {
                    first_name: data.contact.firstName,
                    last_name: data.contact.lastName,
                    email: data.contact.email,
                    address1: data.address.address1,
                    address2: data.address.address2,
                    city: data.address.city,
                    state: data.address.state,
                    zip: data.address.zip,
                    country: data.address.country,
                    bank_account_number: data.account.accountNumber.replace(/\s+/g, ''),
                    bank_routing_number: data.account.routingNumber.replace(/\s+/g, ''),
                    bank_account_holder_type: data.account.accountHolderType,
                    bank_account_type: data.account.accountType,
                },
            },
            retained: false,
        }),
    })
        .then(typeAdapters_1.unpackSpreedlyResponse)
        .then(typeAdapters_1.extractSpreedlyToken);
}
exports.tokenizeBankAccount = tokenizeBankAccount;
function tokenizeCreditCard(data, config) {
    if (config.spreedlyEnvironmentKey === undefined) {
        return Promise.reject(new Error('Spreedly is not configured.'));
    }
    return fetch(constants_1.SPREEDLY_TOKENIZER_URL +
        '?' +
        new URLSearchParams({ environment_key: config.spreedlyEnvironmentKey }), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            payment_method: {
                credit_card: {
                    first_name: data.contact.firstName,
                    last_name: data.contact.lastName,
                    email: data.contact.email,
                    address1: data.address.address1,
                    address2: data.address.address2,
                    city: data.address.city,
                    state: data.address.state,
                    zip: data.address.zip,
                    country: data.address.country,
                    number: data.card.cardNumber.replace(/\s+/g, ''),
                    verification_value: data.card.verificationValue,
                    year: data.card.expirationYear,
                    month: data.card.expirationMonth,
                },
            },
            retained: false,
        }),
    })
        .then(typeAdapters_1.unpackSpreedlyResponse)
        .then(typeAdapters_1.extractSpreedlyToken);
}
exports.tokenizeCreditCard = tokenizeCreditCard;
function tokenizePayPal(data, config) {
    if (config.spreedlyEnvironmentKey === undefined) {
        return Promise.reject(new Error('Spreedly is not configured.'));
    }
    return fetch(constants_1.SPREEDLY_TOKENIZER_URL +
        '?' +
        new URLSearchParams({ environment_key: config.spreedlyEnvironmentKey }), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            payment_method: {
                payment_method_type: 'paypal',
                first_name: data.contact.firstName,
                last_name: data.contact.lastName,
                email: data.contact.email,
                address1: data.address.address1,
                address2: data.address.address2,
                city: data.address.city,
                state: data.address.state,
                zip: data.address.zip,
                country: data.address.country,
            },
            retained: false,
        }),
    })
        .then(typeAdapters_1.unpackSpreedlyResponse)
        .then(typeAdapters_1.extractSpreedlyToken);
}
exports.tokenizePayPal = tokenizePayPal;
var SpreedlyAsync = (function () {
    function SpreedlyAsync(environmentKey, numberEl, cvvEl, inputStyle) {
        var _this = this;
        this.tokenPromise = null;
        this.tokenResolve = null;
        this.tokenReject = null;
        var Spreedly = (this.spreedly = new window.SpreedlyPaymentFrame());
        Spreedly.on('ready', function () {
            Spreedly.setPlaceholder('number', 'Card Number');
            Spreedly.setFieldType('number', 'text');
            Spreedly.setNumberFormat('prettyFormat');
            Spreedly.setPlaceholder('cvv', 'CVV');
            Spreedly.setFieldType('cvv', 'text');
            if (inputStyle) {
                Spreedly.setStyle('number', inputStyle);
                Spreedly.setStyle('cvv', inputStyle);
            }
        });
        Spreedly.on('errors', function (errors) {
            var errorMessages = errors.map(function (err) { return err.message; });
            var errorMessage = errorMessages.join(' ');
            if (_this.tokenPromise && _this.tokenReject) {
                _this.tokenReject(new Error(errorMessage));
            }
            else {
                throw new Error(errorMessage);
            }
        });
        Spreedly.on('paymentMethod', function (token) {
            if (_this.tokenPromise && _this.tokenResolve) {
                _this.tokenResolve(token);
                _this.tokenPromise = null;
            }
            else {
                throw new Error('No pending tokenization request');
            }
        });
        Spreedly.init(environmentKey, {
            numberEl: numberEl,
            cvvEl: cvvEl,
        });
    }
    SpreedlyAsync.prototype.tokenizeCreditCard = function (fields) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.tokenPromise) {
                    throw new Error('Tokenization already in progress');
                }
                this.tokenPromise = new Promise(function (resolve, reject) {
                    _this.tokenResolve = resolve;
                    _this.tokenReject = reject;
                    _this.spreedly.tokenizeCreditCard(fields);
                });
                return [2, this.tokenPromise];
            });
        });
    };
    return SpreedlyAsync;
}());
exports.SpreedlyAsync = SpreedlyAsync;
